<template>
  <t-layout :showNav="false">
    <div class="issueTicket-page">
      <div class="loading-wrap">
        <div class="inner"></div>
      </div>
    </div>
  </t-layout>
</template>

<script>
export default {
  name: 'issueTicketView',
  components: {},
  data() {
    return {
      user_coupon_id: null,
      url: ''
    }
  },
  created() {},
  activated() {
    window.scrollTo(0, 0)
    this.$store.commit('setTitle', '出票中')
    const options = this.$route.query
    this.id = parseInt(options.id)
    this.user_coupon_id = options.user_coupon_id
    this.url = decodeURIComponent(options.url)

    this.postLotteryAutoOrder()
  },
  methods: {
    postLotteryAutoOrder() {
      this.$api.coupon.postLotteryAutoOrder({ url: this.url }).then(result => {
        let res = result.data

        if (res.code == 0) {
          const orderInfo = res.data
          const { recorders, order } = orderInfo
          // const printInfo = recorders[0]
          const refound_num = order.refound_num

          if (refound_num == 0) {
            setTimeout(() => {
              this.toOrderDetail()
            }, 2500)
          } else {
            setTimeout(() => {
              this.$toast({
                duration: 2000,
                message: '出票失败'
              })
              this.$router.back()
            }, 2000)
          }
        } else {
          setTimeout(() => {
            this.$router.back()
          }, 2000)
        }
      })
    },

    async toOrderDetail(state) {
      let data = { id: Number(this.user_coupon_id) }
      const res = await this.$api.coupon.getUserCouponInfo(data)

      let result = res.data || {}

      let couponInfo = result.data.coupon_info || {}
      if (couponInfo.order_no) {
        this.$router.replace({
          path: `/lottery/detail?from=user&id=${this.id}&user_coupon_id=${this.user_coupon_id}&needShowToast=1`
        })
      } else {
        if (state == 'timeout') {
          this.$toast({
            duration: 2000,
            message: '请求超时，请稍后重试'
          })
          this.$router.back()
        } else {
          setTimeout(() => {
            this.toOrderDetail('timeout')
          }, 2500)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.issueTicket-page {
  width: 100%;
  min-height: 100vh;
  .loading-wrap {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    background: rgba(0, 0, 0, 0.85);

    .inner {
      width: 600rpx;
      height: 1197.72rpx;
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: url(https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/alert-loading-v2.png)
        no-repeat top center;
      background-size: 100% 100%;
    }
  }
}
</style>
